import {
  Flex,
  isDarkThemeMixin,
  isMobileStyleMixin,
  Link,
  styleMixinFocusOutline,
  styleMixinInvertedFocusOutline,
  Text,
  TextButton,
} from '@amzn/storm-ui';
import styled, { css } from 'styled-components';

export const ContextBarWrapper = styled(Flex).attrs({
  justifyContent: 'start',
  alignItems: 'center',
  padding: 'xxxsmall',
  grow: 1,
})`
  overflow: hidden;

  ${isMobileStyleMixin(css`
    align-items: center;
    padding: ${({ theme }) => theme.spacing.xsmall.default};
  `)}
`;

export const MobileMenuButton = styled(TextButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xsmall.default};
  margin-inline-end: ${({ theme }) => theme.spacing.xsmall.default};

  &:focus-visible {
    ${styleMixinInvertedFocusOutline};

    ${isDarkThemeMixin(css`
      ${styleMixinFocusOutline};
    `)};
  }
`;

export const MobileMenuButtonIcon = styled.svg`
  width: 18px;
  height: 16px;

  & > path {
    fill: ${({ theme }) => theme.text.color.inverted};

    ${isDarkThemeMixin(css`
      fill: ${({ theme }) => theme.text.color.default};
    `)};
  }
`;

export const BreadcrumbsPageName = styled(Text).attrs({
  weight: 'bold',
})`
  display: inline-block;
  white-space: nowrap;

  ${isMobileStyleMixin(css`
    font-size: 15px;
  `)}
`;

export const PageHeaderSectionWrapper = styled(Link)`
  && {
    text-decoration: none;
  }

  border-radius: ${({ theme }) => theme.border.radius.medium};

  :focus {
    outline: none;
  }

  :focus-visible {
    ${styleMixinInvertedFocusOutline};

    ${isDarkThemeMixin(css`
      ${styleMixinFocusOutline};
    `)};
  }
`;

export const CategoryTitleWrapper = styled(Flex).attrs({ direction: 'column' })`
  & span[class*='Tag-sc-storm-ui'] {
    bottom: 1px;
  }
`;
